import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { maxValue, minValue, number, NumberInput, ReferenceInput, required } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const StateExamSchedule = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      <NumberInput
        label="Година"
        source="year"
        type="number"
        step={1}
        validate={[required(), minValue(2020), maxValue(2999), number()]}
        onChange={e => handleParamChange("year", e.target.value)}
        onWheel={e => e.target.blur()}
      />
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId: structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default StateExamSchedule;
